import { makeStyles } from '@rbx/ui';
import { getAppMainHeight, leftNavWidth, minSpecBannerHeight } from '../constants/layoutConstants';

const useAppLayoutStyles = makeStyles<{
  showSecondaryNavigation: boolean;
  showMinSpecBanner: boolean;
}>()((theme, { showSecondaryNavigation, showMinSpecBanner }) => {
  const height = getAppMainHeight(showSecondaryNavigation, showMinSpecBanner);
  return {
    root: {
      position: 'relative',
    },
    leftNav: {
      height,
      marginTop: `${showMinSpecBanner ? minSpecBannerHeight : 0}px`,
      maxWidth: `${leftNavWidth}px !important`,
      overflowY: 'auto',
      [theme.breakpoints.down('Large')]: {
        display: 'none',
      },
    },
  };
});

export default useAppLayoutStyles;
